import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import ApiConstants from 'src/app/shared/constants/api.constants';
import { environment } from 'src/environments/environment';
import {
  CallDetailsResponse,
  CallFilterParams,
  CallRecordingResponse,
  CallResponse,
} from 'src/app/shared/model/call.model';
import { CallDisputeDetailsResponse } from 'src/app/shared/model/dispute.model';
import { CommonService } from 'src/app/shared/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class CallService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCallData(pageNumber: number, pageSize: number): Observable<CallResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.CALLS}?PageNumber=${pageNumber}&PageSize=${pageSize}`;
    return this.http
      .get<CallResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAllCalls(): Observable<CallResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.CALLS}`;
    return this.http
      .get<CallResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCallById(callId: string): Observable<CallDetailsResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.CALLS}/${callId}`;
    return this.http
      .get<CallDetailsResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getFilteredCallData(callFilterParams: CallFilterParams): Observable<CallResponse> {
    let API_URL = `${this.apiUrl}${ApiConstants.CALLS}?PageNumber=${callFilterParams.pageNumber}&PageSize=${callFilterParams.pageSize}`;

    if (
      callFilterParams.createdFrom !== null &&
      callFilterParams.createdFrom !== '' &&
      callFilterParams.createdFrom !== undefined
    ) {
      API_URL += CommonService.getQuerySingleParams('createdFrom', callFilterParams.createdFrom);
    }

    if (
      callFilterParams.createdTo !== null &&
      callFilterParams.createdTo !== '' &&
      callFilterParams.createdTo !== undefined
    ) {
      API_URL += CommonService.getQuerySingleParams('CreatedTo', callFilterParams.createdTo);
    }

    if (callFilterParams.sortField !== null && callFilterParams.sortField !== undefined) {
      API_URL += CommonService.getQuerySingleParams('SortBy', callFilterParams.sortField);
    }

    if (callFilterParams.sortOrder !== null && callFilterParams.sortOrder !== undefined) {
      API_URL += CommonService.getQuerySingleParams('SortOrder', callFilterParams.sortOrder);
    }

    if (
      callFilterParams.isExport !== null &&
      callFilterParams.isExport !== false &&
      callFilterParams.isExport !== undefined
    ) {
      API_URL += CommonService.getQuerySingleParams('isExport', callFilterParams.isExport);
    }

    return this.http
      .get<CallResponse>(API_URL)
      .pipe(catchError(() => throwError(() => new Error())));
  }

  getDisputesByCallId(callId: string): Observable<CallDisputeDetailsResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.DISPUTE}/${ApiConstants.CALL}/${callId}`;
    return this.http
      .get<CallDisputeDetailsResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getCallRecordingForDownloadMP4(callId: string): Observable<CallRecordingResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.RECORDING_CALLS}${callId}${ApiConstants.DOWNLOAD_MP4}`;
    return this.http
      .get<CallRecordingResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
